import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import copyWorkorderParent from './parent.vue';

var CopyWorkOrderPage = function (_super) {
  __extends(CopyWorkOrderPage, _super);

  function CopyWorkOrderPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CopyWorkOrderPage = __decorate([Component({
    components: {
      copyWorkorderParent: copyWorkorderParent
    }
  })], CopyWorkOrderPage);
  return CopyWorkOrderPage;
}(Vue);

export default CopyWorkOrderPage;